const reads = new Map();

/** Reuse an in-flight or finished read. A failed read is not kept. */
export function cachedRead(key, load) {
  const existing = reads.get(key);
  if (existing) return existing;
  const pending = Promise.resolve().then(load).catch((error) => {
    reads.delete(key);
    throw error;
  });
  reads.set(key, pending);
  return pending;
}

/** Drop one read and any key that starts with `prefix:`. */
export function invalidateReadCache(prefix) {
  const name = String(prefix || '');
  for (const key of [...reads.keys()]) {
    if (key === name || key.startsWith(`${name}:`)) reads.delete(key);
  }
}

export function clearReadCache() {
  reads.clear();
}
